import PortList from "@/lib/PortList";
import { TriangleDownIcon } from "@chakra-ui/icons";
import { Flex, Select } from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';

interface CountryInputProps {
  isMobile: boolean;
  defaultValue?: string | undefined;
  onChange: Function;
}





const CountryInput: React.FC<CountryInputProps> = ({ isMobile, onChange }) => {
  const { t } = useTranslation()
  
  // PortList Country 중복 제거
  const GetPortList = () => {
    let portList: string[] = [];
    
    for(let item of PortList) 
      if(!portList.includes(item.country))
        portList.push(item.country)

    return portList;
  }

  return (
    <Flex w="full">
      <Select
        placeholder={t('form.countryPlaceholder')}
        minW="full"
        h={isMobile ? '50px' : '60px'}
        bgColor="#F7F7F7"
        borderRadius={0}
        border="none"
        icon={<TriangleDownIcon fontSize="8px" />}
        textIndent="1rem"
        defaultValue={t('form.selectCategoryPlaceholder')}
        onChange={(e) => onChange(e.target.value)}
      >
        {GetPortList()?.map((category, idx) => {
          return (
            <option key={idx} value={category}>
              {category}
            </option>
          )
        })}
      </Select>
    </Flex>
  )
}


export default CountryInput